import moment from 'moment'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import Message from '@/modules/i18n/model/Message';

/**
 * Configuración regional
 *
 * Tambien llamado localismo, define la configuración para modificar
 * una aplicación de Artisan en base al idioma o región que
 * este define.
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class Locale {
    public id: number = 0
    public name?: string
    public identifier: string
    public createdAt?: number
    public updatedAt?: number
    public isNew = false
    public messages: Message[] = []

    constructor (id: number = 0, identifier: string = '', name: string = '') {
        this.id = id
        this.identifier = identifier
        this.name = name
    }

    get composedName (): string {
        return `${this.identifier} - ${this.name}`
    }

    get createdAtFormat (): string {
        return moment.unix(this.createdAt || 0).format('LLL')
    }

    get updatedAtFormat (): string {
        return moment.unix(this.updatedAt || 0).format('LLL')
    }

    public static parse (data: KeyValuePair): Locale {
        const locale = new Locale(data['id'] || 0, data['identifier'])
        locale.createdAt = parseInt(data['createdAt'], undefined)
        locale.updatedAt = parseInt(data['updatedAt'], undefined)

        return locale
    }

    public toString () {
        return this.identifier
    }
}
